<template>
    <div>
        <bannerCenter
                :box="box"
                :isShowBot="isShowBot"
                :isShowGao="isShowGao"
        ></bannerCenter>
        <div class="newStatus_thr_message messageHeight">
            <div class="newStatus_text">金控-金逍遥重磅上线</div>
            <div class="newStatus_time">发布时间：2022-10-31</div>
            <div class="newStatus_title">
                <div class="newStatus_title_text">
                    <div>各位合作伙伴：</div>
                    <div class="textIndex">在2022年末，逍遥推手又迎来一重大好消息，现代支付与我公司建立合作关系。</div>
                    <div class="textIndex">现代金融控股（成都）有限公司， 现代金融控股（成都）有限公司于2011年12月22日获得中国人民银行颁发的支付业务许可证, 并于2021年12月再次完成《支付业务许可证》的续展，与中国银行、中国银联、中国建设银行中国移动、中国电信、等近百家机构建立长期战略合作关系。</div>
                    <div class="textIndex">10月31日平台上新金逍遥系列产品！</div>
                    <div class="textIndex">奖励更丰富，达标更简单</div>
                    <div class="textIndex">扫码费率史前最低0.35％</div>
                    <div class="textIndex">特惠支付费率低至0.5％！！！</div>
                    <div class="textIndex">产品火爆，第一批预售1万台通道已开启。</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import bannerCenter from '../../components/bannerCenter'
    export default {
        data(){
            return{
                box:{
                    boxText:'',
                },
                isShowBot:false,
                isShowGao:true
            }
        },
        components:{
            bannerCenter
        }
    }
</script>

<style lang="less" scoped>
    .newStatus_thr_message{
        background: #ffffff;
        padding-bottom: 40px;
        .newStatus_text{
            font-size: 22px;
            font-family: "Microsoft YaHei";
            font-weight: bold;
            color: #010101;
            text-align: center;
            padding: 20px 0 7px;
        }
        .newStatus_time{
            font-size: 14px;
            font-family:"Microsoft YaHei";
            font-weight: 400;
            color: #909090;
            text-align: center;
        }
        .newStatus_title{
            width: 570px;
            font-size: 10px;
            color: #000000;
            margin: 10px auto 0;
            .newStatus_title_text{
                line-height: 25px;
                .textIndex{
                    text-indent: 24px;
                }
            }
        }
    }
    .messageHeight{
        padding-bottom: 300px !important;
    }
</style>
